
<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <router-link to="/create-role"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block text-decoration-none">
          {{ $t('cta.create_role') }}
          <i class="ph-bold ph-plus position-relative ms-5 fs-12"></i>
        </router-link>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <SpinnerLoading v-if="roles === undefined" class="mt-50" />
      <div class="table-responsive" v-else>
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                ID
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('form.name.label') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('feature.roles.type') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
              </th>
            </tr>
          </thead>
          <tbody class="linked">
            <!-- PATIENT ROW -->
            <tr v-for="role in roles" :key="role.id">
              <th class="shadow-none lh-1 fw-medium title text-primary" @click="show(role)">
                <div class="d-flex align-items-center justify-content-start">
                  {{ role.id }}
                </div>
              </th>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis" @click="show(role)">
                {{ role.name }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary" @click="show(role)">
                {{ $t(`feature.roles.$type.${role.type}`) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end">
                <div class="dropdown position-static">
                  <button class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button"
                    data-bs-toggle="dropdown" aria-expanded="false" data-bs-boundary="viewport">
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <router-link :to="{ path: `/role/${role.id}/edit` }"
                        class="dropdown-item d-flex align-items-center">
                        <i class="ph-duotone ph-pencil lh-1 me-8 position-relative top-1"></i>
                        {{ $t('cta.edit') }}
                      </router-link>
                    </li>
                    <li>
                      <button class="dropdown-item d-flex align-items-center" v-on:click="confirmDeleteRole(role)">
                        <i class="ph ph-trash lh-1 me-8 position-relative top-1"></i>
                        {{ $t('cta.delete') }}
                      </button>
                    </li>
                  </ul>

                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- PAGINATION -->
      <TablePagination :count="roles?.length ?? 0" :page="currentPage" :total="total" :pages="lastPage" @change="setPage($event)"/>
    </div>
  </div>
  <ConfirmModal @confirm="deleteRole()" :title="$t('cta.$delete.title')" :message="$t('cta.$delete.message')" />
</template>
  
<script lang="ts">
import { defineComponent } from "vue";
import ConfirmModal from "@/components/Widgets/ConfirmModal.vue";
import SpinnerLoading from "@/components/Widgets/Spinner.vue";
import API from "../../../services/api/api.service";
import { Modal } from "bootstrap";
import { RoleInfo } from "@/utils/models/user.model";
import TablePagination from "@/components/FK/TablePagination.vue";

export default defineComponent({
  name: "RolesList",
  data() {
    return {
      confirmModal: null,
      selectedRole: null,
      roles: undefined,
      currentPage: 1,
      lastPage: 1,
      total: 0,
    } as {
      confirmModal: Modal | null,
      selectedRole: RoleInfo | null;
      roles?: RoleInfo[];
      currentPage: number;
      lastPage: number;
      total: number;
    }
  },
  mounted() {
    this.confirmModal = new Modal('#confirmModal', {});
    this.loadRoles(1);
  },
  methods: {
    confirmDeleteRole(role: RoleInfo) {
      this.selectedRole = role;
      this.$data.confirmModal?.show();
    },
    loadRoles(page: number) {
      this.roles = undefined;
      API.getRoles({page: page}).then((response) => {
        this.roles = response.data?.data ?? [];
        this.total = response.data.total;
        this.lastPage = response.data.last_page;
      })
    },
    setPage(page: number) {
      this.currentPage = page;
      this.loadRoles(page);
    },
    deleteRole(): void {
      API.deleteRole(this.selectedRole?.id!).then((response) => {
        if (response.data.success === true) {
          this.selectedRole = null;
          this.setPage(1);
        }
      }).finally(() => {
        console.log("DELETED_ROLE_ID", this.selectedRole?.id);
      })
    },
    show(role: RoleInfo) {
      this.$router.push({ path: `/role/${role.id}/edit` });
    }
  },
  components: {
    ConfirmModal,
    SpinnerLoading,
    TablePagination
  },
});
</script>